import { LoginScreen, Logo, InfoDescription } from './Login.styles';
import { useTranslation } from '@CS/hooks';
import Button from '@CS/components/Button';
import Content from './content';

type LoginProps = {
  onLogin: () => void;
};

export const Login = ({ onLogin }: LoginProps) => {
  const { text, button, logo } = useTranslation(Content);

  return (
    <LoginScreen aria-label="login">
      <Logo alt="Login" src={logo} />
      <InfoDescription>{text}</InfoDescription>
      <Button onClick={onLogin} text={button} />
    </LoginScreen>
  );
};
